import deMessages from '../locales/de_DE.json';
import merchandisingMessages from '../locales/merchandising';

const DeLang = {
  messages: {
    ...merchandisingMessages,
    ...deMessages,
  },
  locale: 'de-DE',
};
export default DeLang;
